import {
  makeKiddomDeleteRequest,
  makeKiddomGetRequest,
  makeKiddomPostRequest,
  makeKiddomPutRequest,
} from 'infrastructure/api'
import { VanityUrl } from './vanityUrls.types'

export function createVanityUrl(productId: number, url: string) {
  return makeKiddomPostRequest({
    kiddomPath: '/api/engineering/vanity_urls',
    requestBody: {
      product_id: productId,
      url,
    },
  })
}

export function getVanityUrls() {
  return makeKiddomGetRequest<VanityUrl[]>({
    kiddomPath: '/api/engineering/vanity_urls',
  })
}

export function updateVanityUrl(id: number, url: string) {
  return makeKiddomPutRequest({
    kiddomPath: '/api/engineering/vanity_urls',
    requestBody: {
      id,
      url,
    },
  })
}

export function deleteVanityUrl(id: number) {
  return makeKiddomDeleteRequest({
    kiddomPath: '/api/engineering/vanity_urls',
    requestBody: {
      id,
    },
  })
}
